<template>
  <div class="vogue-home-banner type-banner" :class="'type-banner-' + onlyKey">
    <swiper class="swiper" :options="swiperOption" ref="mySwiper2">
      <swiper-slide v-for="list in JSON.parse(products)" :key="onlyKey + list.ID">
        <v-product-card
          :card_animate="
            product_cart_style && product_cart_style.card_animate ? product_cart_style.card_animate : 'default'
          "
          :disable_select="disable_select"
          :show_currency_selector="show_currency_selector"
          :cart_type="cart_type"
          :theme="theme"
          :text_align="text_align"
          :product_price="product_price"
          :card_radio="card_radio"
          :buy_button_style="buy_button_style"
          :sales_label="sales_label"
          :productDetail="list"
          :sale_image="sale_image"
          :show_star="show_star"
          :custom_button="list.custom_button && list.custom_button.custom_button"
          :sale_image_show="product_cart_style && product_cart_style.sale_image_show"
          model="is_card"
          :palette_config="palette_config"
          :keys="keys"
          :isShowMainImg="true"
        ></v-product-card>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination d-block d-md-none"></div>
    <div
      v-if="JSON.parse(products).length >= count"
      class="swiper-button-prev swiper-button-black d-none d-md-block"
      slot="button-prev"
    >
      <svg data-v-19c6ab24="" viewBox="0 0 100 100">
        <path data-v-19c6ab24="" d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path>
      </svg>
    </div>
    <div
      v-if="JSON.parse(products).length >= count"
      class="swiper-button-next swiper-button-black d-none d-md-block"
      slot="button-next"
    >
      <svg data-v-19c6ab24="" viewBox="0 0 100 100">
        <path
          data-v-19c6ab24=""
          d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
          transform="translate(100, 100) rotate(180) "
          class="arrow"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'disable_select',
    'show_currency_selector',
    'cart_type',
    'theme',
    'text_align',
    'product_price',
    'card_radio',
    'card_animate',
    'buy_button_style',
    'sales_label',
    'products',
    'show_star',
    'sale_image',
    'category_msg',
    'button_text',
    'count',
    'button_url',
    'palette_config',
    'keys',
    'product_cart_style',
  ],
  data() {
    return {
      swiperOption: {
        slidesPerView: this.count ? this.count : 6,
        autoplay: true,
        spaceBetween: 35,
        //Swiper4.x版本为小于
        breakpoints: {
          768: {
            //当屏幕宽度小于等于768
            slidesPerView: 2,
            spaceBetween: 15,
          },
        },
        pagination: {
          el: `.type-banner-${this.onlyKey} .swiper-pagination`,
        },
        navigation: {
          nextEl: `.type-banner-${this.onlyKey} .swiper-button-next `,
          prevEl: `.type-banner-${this.onlyKey} .swiper-button-prev `,
        },
      },
    }
  },
  beforeCreate() {
    this.onlyKey = this.randomCoding()
  },
  beforeMount() {},
  computed: {
    //获取swiper实例
    swiper() {
      return this.$refs.mySwiper2.swiper
    },
  },
}
</script>
<style lang="scss">
.vogue-home-banner {
  position: relative;

  .swiper-pagination {
    position: unset;
    width: auto !important;
    margin: 15px auto;
    .swiper-pagination-bullet {
      width: 4px;
      height: 4px;
      margin: 0 5px;
    }
    .swiper-pagination-bullet-active {
      transition: width 0.5s;
      width: 34px;
      border-radius: 10px;
      background: #000;
    }
  }
  .swiper-slide {
    .product_item {
      margin-bottom: 0 !important;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    top: 37%;
    position: absolute;
    width: 45px;
    height: 45px;
    border: none;
    border-radius: 50%;
    background: #fff;
    color: #000;
    cursor: pointer;
    text-align: center;
    z-index: 2;
    box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
    vertical-align: middle;
    line-height: 0;
    transform: scale(1.001);
    line-height: 40px;
    transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out, transform 0.2s ease-in-out,
      color 0.2s ease-in-out;
    overflow: hidden;
    background-image: none !important;
    svg {
      width: auto;
      height: 18px;
      stroke-width: 10px;
      stroke: currentColor;
    }
  }
  .swiper-button-prev {
    left: -55px;
    &:hover {
      svg {
        -webkit-animation: buttonFromRightToLeft 0.5s ease-in-out forwards;
        animation: buttonFromRightToLeft 0.5s ease-in-out forwards;
      }
    }
  }
  .swiper-button-next {
    right: -55px;
    &:hover {
      svg {
        -webkit-animation: buttonFromLeftToRight 0.5s ease-in-out forwards;
        animation: buttonFromLeftToRight 0.5s ease-in-out forwards;
      }
    }
  }
}

@media screen and(max-width:1480px) {
  .vogue-home-banner {
    .swiper-button-prev {
      left: 15px;
    }
    .swiper-button-next {
      right: 15px;
    }
  }
}
@media (max-width: 767px) {
  .vogue-home-banner {
    // .swiper-slide {
    //   width: 50% !important;
    // }
    .swiper-button-prev,
    .swiper-button-next {
      height: 22px;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
  }
}
</style>